import { render } from "./order.vue?vue&type=template&id=4008f3c6&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4008f3c6"

export default script